var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.15,
    height: 109.5,
    viewBox: "0 0 99.15 109.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M13.2-108.6v61.2H26.1c3.6-8.55,11.55-14.25,22.5-14.25,15.75,0,23.7,9,23.7,24.45,0,14.85-7.35,25.95-23.85,25.95C35.7-11.25,26.85-18,24.3-29.4H10.95C13.65-11.85,26.7.3,48.3.3,73.65.3,85.35-16.5,85.35-37.5c0-16.8-8.4-35.85-34.8-35.85-10.65,0-20.25,4.8-24.75,10.95V-96.6H78.45v-12ZM110.1-8.4a9.1,9.1,0,0,0-9-9.3,9.158,9.158,0,0,0-9.3,9.3A9.158,9.158,0,0,0,101.1.9,9.1,9.1,0,0,0,110.1-8.4Z",
    transform: "translate(-10.95 108.6)",
    fill: "#005465"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.e657aecd644cd54e4f4a5200a963b173.svg";
export { ForwardRef as ReactComponent };